// eslint-disable react/jsx-props-no-spreading

import {useCallback, useEffect, useMemo, useState} from "react";

// @mui material components
import {Grid, Tooltip, Typography, Box, Button} from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import data from "../../dashboard/components/Projects/data";
import useApi from "../../../components/Utils/api";
import toast from "react-hot-toast";
import {DatePicker} from "rsuite";
import { afterToday } from "rsuite/cjs/DateRangePicker/disabledDateUtils";
import {
    DataGrid,
    GridToolbarContainer,
    GridToolbarColumnsButton, GridToolbarFilterButton, GridToolbarDensitySelector, GridToolbarExport
} from '@mui/x-data-grid';
import {styled} from "@mui/material/styles";
const getTooltipMessage = (status) => {
    switch (status) {
        case "SETTLEMENT_INITIATED":
            return "Settlement has been initiated.";
        case "PENDING":
            return "Settlement is pending.";
        case "FAILED":
            return "Settlement failed.";
        case "SETTLED":
            return "Settlement is done.";
        default:
            return "Unknown status.";
    }
};
function CardSettlementSummary() {
  const { cardSettlementSummaryTableColumns } = data();
  const [summary, setSummary] = useState([]);
  const [lastMonthDateRange, setLastMonthDateRange] = useState(new Date());
  const [rowSelectionModel, setRowSelectionModel] = useState([]);
  const handleSettleAll = () => {
    const merchantsToSettle = rowSelectionModel.map((merchantRow) => {
      if (summary[merchantRow].settlementStatus === 'PENDING' && summary[merchantRow].settlementAllowed) return {
        merchantId : summary[merchantRow].merchantId,
        settlementAmount : summary[merchantRow].settlementAmount
      };
    })
    const data = {
        settlementSummary : merchantsToSettle,
        date : formatDate(lastMonthDateRange),
        currency: summary[rowSelectionModel[0]].currency,
        paymentMethod: summary[rowSelectionModel[0]].source
    }
    api.post("settlements", data)
        .then((response) => {
          if (response.data?.data?.status === "INITIATED") {
            toast.success("Settlement initiated successfully. Batch id is "+response.data.data.batchId, { id: 'SuccessfullyInitated' });
            if(lastMonthDateRange !== null){
                getCardSettlementSummary(lastMonthDateRange);
                setRowSelectionModel([]);
            }
          } else {
              console.log(response.data);
              if (response.data?.error?.message) {
                  toast.error(response.data?.error?.message, {id: "NotSuccessfullyInitated"});
                  return;
              }
            toast.error("Something wrong happened, couldn't inititate settlement.", {id: "NotSuccessfullyInitated"});
          }
        })
        .catch((error) => {
            if (error.response && error.response.status === 500) {
                toast.error(error.response.data.error.message, { id: "FiveHundred" });
                return;
            }
          console.log("error", error)
        })
  };
  // const [fromDate, setFromDate]= useState(lastMonthDateRange[0]);
  // const [toDate, setToDate ]= useState(lastMonthDateRange[1]);
  const api = useApi();
    const formatDate = (date) => {
        const inputDate = new Date(date);
        const year = inputDate.getFullYear();
        const month = String(inputDate.getMonth() + 1).padStart(2, '0');
        const day = String(inputDate.getDate()).padStart(2, '0');
        return `${month}/${day}/${year}`;
    };
  const getCardSettlementSummary = (lastMonthDateRange) => {
    if(lastMonthDateRange == null) return;
    setLastMonthDateRange(lastMonthDateRange);
    const data = {
      date : formatDate(lastMonthDateRange)
    }
    api.post("settlements/summary", data)
        .then((response) => {
          if (response.data.data.settlementSummary.length > 0) {
            const modifiedData = response.data.data.settlementSummary.map((item, index) => {
              // const action = (
              //     <MDBox display="flex" alignItems="center" lineHeight={1}>
              //       <MDButton color="info" variant="info">Settle</MDButton>
              //     </MDBox>
              // );
              // return { ...item, action, id: index };
              return { ...item, id: index };
            });
            setSummary(modifiedData);
          } else {
            toast.error("No Record Found", { id: "NoRecordFound" });
            setSummary([])
          }
        })
        .catch((error) => {
          if (error.response && error.response.status === 403) {
            // Check if a toast with the same message is already on the screen
            toast.error("You do not have permission to perform this action.", { id: "PermissionError" });
            return;
          }
          // Check if a toast with the same message is already on the screen
          toast.error("No Record Found", { id: "NoRecordFound" });
        });
  }
    const handleRowSelectionChange = useCallback((newSelection) => {
        setRowSelectionModel(newSelection);
    }, []);
  function CustomToolbar() {
    return (
        <GridToolbarContainer>
          <GridToolbarColumnsButton />
          <GridToolbarFilterButton />
          <GridToolbarDensitySelector />
          <GridToolbarExport />
          {rowSelectionModel.length > 0 ? <Button
              onClick={handleSettleAll}
          >
            Settle All
          </Button> : <></>}
        </GridToolbarContainer>
    );
  }
    const StyledDataGrid = styled(DataGrid)({
        '&': {
            color: '#7b809a !important',
            fontSize: '0.875rem !important',
        },
        '& .MuiDataGrid-virtualScroller': {
            overflowX: 'scroll !important',
        },
        '& .MuiDataGrid-cellContent': {
            paddingLeft: '2px',
        },
        '& .MuiDataGrid-row.greyed': { backgroundColor: '#f5f5f5', color: '#9e9e9e' },
    });
    const renderCellWithTooltip = (params) => {
        const { row } = params;
        const isPending = row.settlementStatus !== 'PENDING';
        const isAllowed = !row.settlementAllowed;

        let tooltipMessage = '';
        if (isPending) {
            switch (row.settlementStatus) {
                case "SETTLEMENT_INITIATED":
                    tooltipMessage = "Settlement has been initiated.";
                    break;
                case "FAILED":
                    tooltipMessage = "Settlement failed.";
                    break;
                case "SETTLED":
                    tooltipMessage = "Settlement is done.";
                    break;
                default:
                    tooltipMessage = "Settlement is pending.";
                    break;
            }
        } else if (isAllowed) {
            tooltipMessage = 'Settlement is not allowed due to unavailability of relevant currency settlement account.';
        }

        return (
            <Tooltip
                title={
                    <Typography sx={{ fontSize: 12 }}>
                        {tooltipMessage}
                    </Typography>
                }
                disableHoverListener={!tooltipMessage}
            >
                <span>{params.value}</span>
            </Tooltip>
        );
    };

    const columnsWithTooltip = useMemo(() =>
    cardSettlementSummaryTableColumns.map((col) => {
      if (col.field === 'batchNo') {
        return {
          ...col,
          renderCell: (params) => {
            if (params.row.batchNo && params.row.settlementStatus !== "PENDING") {
              return (
                <Box 
                  display="flex" 
                  alignItems="center" 
                  sx={{ 
                    gap: 0.5,
                    height: '100%',
                    justifyContent: 'flex-start',
                    paddingLeft: '2px',
                    '& .MuiButton-root': {
                      minWidth: 'auto',
                      padding: '4px 8px',
                      fontSize: '0.75rem',
                      backgroundColor: 'transparent',
                      color: 'info.main',
                      '&:hover': {
                        backgroundColor: 'rgba(0, 0, 0, 0.04)'
                      }
                    }
                  }}
                >
                  <Typography 
                    variant="body2" 
                    sx={{ 
                      fontWeight: 500,
                      color: 'text.secondary'
                    }}
                  >
                    {params.row.batchNo}
                  </Typography>
                  <Button 
                    variant="text"
                    size="small"
                    onClick={() => {
                      api.get(`settlements/${params.row.batchNo}`)
                        .then((response) => {
                          toast.success(response.data.data.settlementStatusResponses[0].statusDescription, { id: "SUCCESS" });
                        })
                        .catch((error) => {
                          if (error.response) {
                            const status = error.response.status;
                            if (status === 400) {
                              toast(error.response.data.error.message, { id: "BAD_REQUEST" });
                            } else if (status === 403) {
                              toast.error("You do not have permission to perform this action.", { id: "PermissionError" });
                            } else if (status === 500) {
                              toast(error.response.data.error.message, { id: "SETTLEMENT_FAILED" });
                            }
                          } else {
                            toast.error("No Record Found", { id: "NoRecordFound" });
                          }
                        });
                    }}
                  >
                    Check
                  </Button>
                </Box>
              );
            }
            return null;
          }
        };
      }
      if (col.renderCell) {
        return col;
      }
      return {
        ...col,
        renderCell: renderCellWithTooltip,
      };
    })
  , [cardSettlementSummaryTableColumns, api]);
    useEffect(() => {
        getCardSettlementSummary(lastMonthDateRange);
    },[]);
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={6} mb={3}>
        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12} lg={12} sx={{ width: "100%" }}>
            <Grid item xs={12} md={12} lg={12}>
              <MDBox mb={3} textAlign={"center"}>
                <DatePicker
                    oneTap
                    disabledDate={afterToday()}
                    onChange={(date) => getCardSettlementSummary(date)}
                    format="yyyy-MM-dd"
                    value={lastMonthDateRange ? lastMonthDateRange : ''}
                />
              </MDBox>
            </Grid>
            {/*<DataTable*/}
            {/*  table={{ columns : cardSettlementSummaryTableColumns, rows : summary }}*/}
            {/*  showTotalEntries={true}*/}
            {/*  isSorted={true}*/}
            {/*  noEndBorder*/}
            {/*  entriesPerPage={true}*/}
            {/*  canSearch={true}*/}
            {/*/>*/}
            {/*<TableContainer sx={{ boxShadow: "none", width: '100%' }}>*/}
            <StyledDataGrid
                autoHeight
                style={{ backgroundColor: 'white',  }}
                rows={summary}
                columns={columnsWithTooltip}
                initialState={{
                  pagination: {
                    paginationModel: {
                      pageSize: 10,
                    },
                  },
                }}
                pageSizeOptions={[10, 25, 50, 100]}
                checkboxSelection
                getRowClassName={(params) => (params.row.settlementStatus !== 'PENDING' || !params.row.settlementAllowed ? 'greyed' : '')}
                isRowSelectable={(params) => params.row.settlementStatus === 'PENDING' && params.row.settlementAllowed}
                disableRowSelectionOnClick
                onRowSelectionModelChange={handleRowSelectionChange}
                rowSelectionModel={rowSelectionModel}
                indeterminateCheckboxAction="select"
                slots={{
                    toolbar: CustomToolbar,
                }}
                slotProps={{
                    toolbar: {
                        csvOptions: {
                            filename: 'settlement-summary',
                            delimiter: ',',
                            utf8WithBom: true,
                        },
                        printOptions: {
                            hideFooter: true,
                            hideToolbar: true,
                            includeCheckboxes: true,
                        }
                    }
                }}
            />
            {/*</TableContainer>*/}
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default CardSettlementSummary;
